import { makeStyles } from "../../shared";

export const eventAttendingAndCancelStyles = makeStyles({
  cancelRegitsrationDialogCancelButtonIconMobile: {
    width: "24px",
    height: "24px",
  },
});
